
const mockLeadActivityData = [
  [
    {
      event: "session_started",
      data: {},
      timestamp: "2026-05-11T10:00:00.000Z",
    },
    {
      event: "view_changed",
      data: { view: "projects" },
      timestamp: "2026-05-11T10:00:10.000Z",
    },
    {event:"filter_opened", data: { filter: "location" }, timestamp: "2026-05-11T10:00:15.000Z"},
    {
      event: "filter_location_changed",
      data: { location: "OMR, Chennai" },
      timestamp: "2026-05-11T10:00:18.000Z",
    },
    {event:"filter_budget_changed", data: { budget_min: 5000000, budget_max: 15000000 }, timestamp: "2026-05-11T10:00:20.000Z"},
    {event:"filter_budget_changed", data: { budget_min: 7000000, budget_max: 20000000 }, timestamp: "2026-05-11T10:00:22.000Z"},
    {event:"filter_closed", data: { filter: "location" }, timestamp: "2026-05-11T10:00:24.000Z"},
    {
      event: "property_viewed",
      data: { property: "Casagrand Zenith" },
      timestamp: "2026-05-11T10:00:32.000Z",
    },
    {
      event: "view_changed",
      data: { view: "chat" },
      timestamp: "2026-05-11T10:00:45.000Z",
    },
    {
      event: "session_ended",
      data: {},
      timestamp: "2026-05-11T10:01:00.000Z",
    },
  ],

//   [
//     {
//       event: "session_started",
//       data: {},
//       timestamp: "2026-05-11T11:10:00.000Z",
//     },
//     {
//       event: "view_changed",
//       data: { view: "projects" },
//       timestamp: "2026-05-11T11:10:05.000Z",
//     },
//     {
//       event: "filter_budget_changed",
//       data: {
//         budget_min: 5000000,
//         budget_max: 15000000,
//       },
//       timestamp: "2026-05-11T11:10:18.000Z",
//     },
//     {
//       event: "property_viewed",
//       data: { property: "Aurevia Meadows" },
//       timestamp: "2026-05-11T11:10:40.000Z",
//     },
//     {
//       event: "session_ended",
//       data: {},
//       timestamp: "2026-05-11T11:11:10.000Z",
//     },
//   ],

//   [
//     {
//       event: "session_started",
//       data: {},
//       timestamp: "2026-05-11T12:00:00.000Z",
//     },
//     {
//       event: "view_changed",
//       data: { view: "projects" },
//       timestamp: "2026-05-11T12:00:08.000Z",
//     },
//     {
//       event: "view_changed",
//       data: { view: "chat" },
//       timestamp: "2026-05-11T12:00:30.000Z",
//     },
//     {
//       event: "view_changed",
//       data: { view: "projects" },
//       timestamp: "2026-05-11T12:00:50.000Z",
//     },
//     {
//       event: "property_viewed",
//       data: { property: "Brigade Residences" },
//       timestamp: "2026-05-11T12:01:02.000Z",
//     },
//     {
//       event: "session_ended",
//       data: {},
//       timestamp: "2026-05-11T12:01:30.000Z",
//     },
//   ],
];

export default mockLeadActivityData;